import React, { ReactNode } from "react";
import { Typography } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Wrapper } from "./styles";

export default function CobeeDatePicker({
  adaptToContainer,
  customInput,
  selectedDate,
  onChange,
  showMonthYearPicker,
  ...rest
}: {
  adaptToContainer?: boolean;
  customInput?: ReactNode;
  selectedDate: string | Date;
  onChange: (e: any) => void;
  showMonthYearPicker?: boolean;
  minDate?: Date;
}) {
  return (
    <Wrapper adaptToContainer={adaptToContainer}>
      <DatePicker
        selected={selectedDate ? new Date(selectedDate) : new Date()}
        customInput={customInput}
        formatWeekDay={(nameOfDay) => (
          <Typography variant="body2">{nameOfDay.substr(0, 1)}</Typography>
        )}
        onChange={onChange}
        {...rest}
      />
    </Wrapper>
  );
}
